import { Observable } from "rxjs";
import { TiresWarrantyRequest } from "../../model/tires-warranty.model";

export abstract class TiresWarrantyAdapter {
  abstract startTiresWarranty (
    request: TiresWarrantyRequest
  ): Observable<void>
}
